export enum WalletEvent {
    BALANCE_CHANGED = 'onWalletBalanceChanged',
    NOT_ENOUGH_BALANCE = 'onWalletNotEnoughBalance',
    COIN_VALUE_CHANGED = 'onCoinValueChanged'
}
